import { icons } from "./icons";

export const notices = [
  {
    name :  "Monday, 6th Apirl 2020",
    notices: "Book for General Service",
    btn: "14:07-21/11/2010",
    icon: icons.noticesIcon1
  },

  {
    name :  "Thursday, 24th October 2021",
    notices: "Vehicle LV 001 has been marked for recall.",
    btn: "14:07-21/01/2008",
    icon: icons.noticesIcon2
  },

  {
    name :  "Monday, 13th August 2018",
    notices: "Maintenance Completed, Collect",
    btn: "14:07-21/07/2020",
    icon: icons.noticesIcon3
  },
]

export const avaliable = [
  {
    name : 'Asset - Fuel Consumed (10)',
    icon : icons.availableIcon
  },
  {
    name : 'Asset - Odometer (km)',
    icon : icons.availableIcon
  },
  {
    name : 'Asset - Runtime (1',
    icon : icons.availableIcon
  },
  {
    name : 'Asset - Speed (hr)',
    icon : icons.availableIcon
  },
  {
    name : 'Engine Temperature (deg C)',
    icon : icons.availableIcon
  }
]
